import React from 'react'
import CBILogo from '../../img/logo-cbi.png'

export default () => (
    <footer className="footer">
        <div className="logo-div is-vcentered no-margin">
            <a href="https://consbio.org" target="_blank" className="no-style" rel="noreferrer">
                <img className="cbi-logo" src={CBILogo} alt="Conservation Biology Institute Logo" /> Created by
                Conservation Biology Institute
            </a>
        </div>
    </footer>
)
